import { BaseDto } from "src/dtos/common/baseDto";

export interface WmsStockLotDto extends BaseDto {

	warehouseCd: string;		// 창고코드
	warehouseNm: string;		// 창고명
	lotNo: string;				// LOTNO(기본키)
	purchaseLotNo: string;		// 구매 Lot No
	itemCd: string;				// 품목코드/ITEMCD.MSTITEM(기본키)
	itemNm: string;				// 품명
	itemSpec: string;			// 규격
	itemUnit: string;			// 단위
	itemStatus: string;			// 재고등급
	lotQty: number;				// 재고량
	lotCreateDt: string;		// 재고 최초 입고일자
	transportNo: string;		// 입고전표전호
	itemNo: string;				// 입고항목번호 - 품목번호
	remark: string;				// 비고	

	inserted: boolean;
	isModified: boolean;

}

export const defaultWmsStockLotDto: WmsStockLotDto = {
	valueIndex: 0,
	orderIndex: 0,
	orderIndexSeq: 0,
	
	warehouseCd: '',
	warehouseNm: '',
	lotNo: '',
	purchaseLotNo: '',
	itemCd: '',
	itemNm: '',
	itemSpec: '',
	itemUnit: '',
	itemStatus: '',
	lotQty: 0,
	lotCreateDt: '',
	transportNo: '',
	itemNo: '',
	remark: '',

	inserted: false,
	isModified: false,
}
